module.exports = __webpack_public_path__ + "img/42892ee.png";